import React from 'react';
export var idLoader = 'user-info-loader'; // This has no visual style for now to replicate OC-Header UX

var UserInfoLoader = function UserInfoLoader() {
  return /*#__PURE__*/React.createElement("div", {
    "data-test": idLoader
  });
};

export default UserInfoLoader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/shared/desktop/UserInfoLoader.js
// module id = 959
// module chunks = 11